module.exports = __webpack_public_path__ + "media/images/admin/icons/corner-down-left-c0e4e5bcbff6dece0b25379aa12f837f.svg";